import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Helmet, HelmetProvider } from "react-helmet-async";

import './App.css';
import Home from './pages/Home/Home';
import NotFound from './pages/NotFound/NotFound';
import { useStateContext } from './context/ContextProvider';

// PROJECTS 
import AziziVeniceNina from './pages/Projects/Azizi/Venice/AziziVeniceNina';
import AziziVenice from './pages/Projects/Azizi/Venice/AziziVenice';
import AziziVeniceSnapchat from './pages/Projects/Azizi/Venice/AziziVeniceSnapchat';
import LanguageWrapper from './components/Language/LanguageWrapper';
import Thankyou from './pages/Thankyou/Thankyou';
import PrivacyPolicy from './pages/PrivacyPolicy/PrivacyPolicy';
import AziziRivieraRetail from './pages/Projects/Azizi/Riviera-Retail/AziziRivieraRetail';
import AziziRivieraRetailSnapchat from './pages/Projects/Azizi/Riviera-Retail/AziziRivieraRetailSnapchat';
import TestPage from './pages/Projects/TestDev/TestPro/TestPage';
import AziziVeniceSnapchatNina from './pages/Projects/Azizi/Venice/AziziVeniceSnapchatNina';
import AziziRivieraRetailNina from './pages/Projects/Azizi/Riviera-Retail/AziziRivieraRetailNina';
import AziziRivieraRetailSnapchatNina from './pages/Projects/Azizi/Riviera-Retail/AziziRivieraRetailSnapchatNina';
import DamacRiversideNina from './pages/Projects/Damac/Riverside/DamacRiversideNina';
import DamacRiversideSnapchatNina from './pages/Projects/Damac/Riverside/DamacRiversideSnapchatNina';
import Blocked from './pages/NotFound/Blocked';
import AziziMilanNina from './pages/Projects/Azizi/Milan/AziziMilanNina';
import AziziMilanSnapchatNina from './pages/Projects/Azizi/Milan/AziziMilanSnapchatNina';
import AziziMilanApoelezz from './pages/Apoelezz/Azizi/Milan/AziziMilanApoelezz';
import BinghattiAquariseApoelezz from './pages/Apoelezz/Binghatti/Aquarise/BinghattiAquariseApoelezz';
import TigerAnandaApoelezz from './pages/Apoelezz/Tiger/Ananda/TigerAnandaApoelezz';
import AziziVeniceHikal from './pages/Hikal/Azizi/Venice/AziziVeniceHikal';
import AziziVeniceAsm from './pages/Asm/Azizi/Venice/AziziVeniceAsm';
import AziziMilanAsm from './pages/Asm/Azizi/Milan/AziziMilanAsm';
import AziziMilanHikal from './pages/Hikal/Azizi/Milan/AziziMilanHikal';
import BinghattiCircleHikal from './pages/Hikal/Binghatti/Circle/BinghattiCircleHikal';

const routes = [
  // HOME 
  {
    path: "/",
    element: <Home />,
    pageName: "Home",
    title: "DoDeal Properties",
    description: "DoDeal Properties",
  },
  // PRIVACY POLICY 
  {
    path: "/privacypolicy",
    element: <PrivacyPolicy />,
    pageName: "Privacy Policy",
    title: "DoDeal Properties",
    description: "DoDeal Properties",
    language: "en"
  },
  // BLOCKED IP 
  {
    path: "/blocked",
    element: <Blocked language={"en"} />,
    pageName: "Blocked",
    title: "DoDeal Properties | Blocked",
    description: "DoDeal Properties",
  },
  // THANK YOU 
  {
    path: "/thankyou",
    element: <Thankyou language={"en"} />,
    pageName: "Thank you",
    title: "DoDeal Properties",
    description: "DoDeal Properties",
    language: "en"
  },
  {
    path: "/thankyou/ar",
    element: <Thankyou language={"ar"} />,
    pageName: "Thank you",
    title: "DoDeal Properties",
    description: "DoDeal Properties",
    language: "ar"
  },
  // PROJECTS 
  // TEST - EN
  {
    path: "/projects/test",
    element: <TestPage language={"en"} />,
    pageName: "DoDeal Dev",
    title: "DoDeal Dev",
    description: "DoDeal Properties | DoDeal Dev",
    language: "en"
  },
  // TEST - AR
  {
    path: "/projects/test/ar",
    element: <TestPage language={"ar"} />,
    pageName: "DoDeal Dev",
    title: "DoDeal Dev",
    description: "DoDeal Properties | DoDeal Dev",
    language: "ar"
  },

  // C1HP - HIKAL - PROJECTS
  // AZIZI - VENICE - EN 
  {
    // path: "/c1hp/azizi/venice",
    path: "/projects/azizi/venice",
    element: <AziziVeniceHikal language={"en"} />,
    pageName: "Azizi Venice",
    title: "Luxury Apartments in Dubai – Find Your Dream Home!",
    description: "Your luxurious home in Dubai is waiting to fulfill all your dreams – Find your apartment today with only 65800 AED  down  payment",
    language: "en",
    bodyBackgroundClass: "black-bg"
  },
  // AZIZI - VENICE - AR
  {
    // path: "/c1hp/azizi/venice/ar",
    path: "/projects/azizi/venice/ar",
    element: <AziziVeniceHikal language={"ar"} />,
    pageName: "Azizi Venice",
    title: "فرصة لا تعوض! شقق فاخرة في أفضل مواقع دبي للبيع.",
    description: "وحدات سكنيه ،  تجربة فاخرة بانتظارك. لا تفوت الفرصة، احجز الآن لتعيش في قلب الرفاهية والرقي مع مقدم يبدء من 65800 درهم ",
    language: "ar",
    bodyBackgroundClass: "black-bg"
  },
  // AZIZI - MILAN - EN 
  {
    path: "/projects/azizi/milan",
    element: <AziziMilanHikal language={"en"} />,
    pageName: "Azizi Milan",
    title: "Dubai Meets Italy – Azizi Milan Apartments for Sale",
    description: "Live where Italy meets Dubai. Azizi Milan offers elegant studios to 3BR homes, world-class amenities & a prime location near IMG Worlds",
    language: "en",
    bodyBackgroundClass: "black-bg"
  },
  // AZIZI - MILAN - AR
  {
    path: "/projects/azizi/milan/ar",
    element: <AziziMilanHikal language={"ar"} />,
    pageName: "Azizi Milan",
    title: "دبي بطابع إيطالي – شقق Azizi Milan للبيع",
    description: "عيش في مكان يجمع بين سحر دبي وأناقة إيطاليا. Azizi Milan بتقدم شقق من ستوديو الى 3 غرف نوم، مع خدمات راقية وموقع استثنائي بجانب IMG Worlds.",
    language: "ar",
    bodyBackgroundClass: "black-bg"
  },
  // BINGHATTI - CIRCLE - EN 
  {
    path: "/projects/binghatti/circle",
    element: <BinghattiCircleHikal language={"en"} />,
    pageName: "Binghatti Circle",
    title: "Live an Modern  Lifestyle in the Heart of Jumeirah Village Circle (JVC)",
    description: "Studios to 3BR apartments designed for comfort & style. Smart spaces for city life or spacious homes for families in vibrant JVC.",
    language: "en",
    bodyBackgroundClass: "black-bg"
  },
  // BINGHATTI - CIRCLE - AR
  {
    path: "/projects/binghatti/circle/ar",
    element: <BinghattiCircleHikal language={"ar"} />,
    pageName: "Binghatti Circle",
    title: " شﻋ ةﺎﯾﺣ ﺔﯾرﺻﻋ  ﻲﻓ بﻠﻗ ﺔﯾرﻗ ارﯾﻣﺟ",
    description: " شقق من الاستوديو حتى 3 غرف نوم بتصميم يجمع بين الراحة والأناقة. مساحات ذكية لحياة المدينة و منازل واسعة  تناسب العائلات في قرية جميرا النابضة بالحياة.",
    language: "ar",
    bodyBackgroundClass: "black-bg"
  },

  // C4PN - PROPERTY - OFFER
  // AZIZI - VENICE - EN 
  {
    path: "/offer/azizi/venice",
    element: <AziziVeniceNina language={"en"} />,
    pageName: "Azizi Venice",
    title: "Luxury Apartments in Dubai – Find Your Dream Home!",
    description: "Your luxurious home in Dubai is waiting to fulfill all your dreams – Find your apartment today with only 65800 AED  down  payment.",
    language: "en"
  },
  // AZIZI - VENICE - AR
  {
    path: "/offer/azizi/venice/ar",
    element: <AziziVeniceNina language={"ar"} />,
    pageName: "Azizi Venice",
    title: "فرصة لا تعوض! شقق فاخرة في أفضل مواقع دبي للبيع.",
    description: "وحدات سكنيه ،  تجربة فاخرة بانتظارك. لا تفوت الفرصة، احجز الآن لتعيش في قلب الرفاهية والرقي مع مقدم يبدء من 65800 درهم ",
    language: "ar"
  },
  // AZIZI - VENICE - EN - S
  {
    path: "/offer/azizi/venice/en-s",
    element: <AziziVeniceSnapchatNina language={"en"} />,
    pageName: "Azizi Venice",
    title: "Luxury Apartments in Dubai – Find Your Dream Home!",
    description: "Your luxurious home in Dubai is waiting to fulfill all your dreams – Find your apartment today with only 65800 AED  down  payment.",
    language: "en"
  },
  // AZIZI - VENICE - AR - S
  {
    path: "/offer/azizi/venice/ar-s",
    element: <AziziVeniceSnapchatNina language={"ar"} />,
    pageName: "Azizi Venice",
    title: "فرصة لا تعوض! شقق فاخرة في أفضل مواقع دبي للبيع.",
    description: "وحدات سكنيه ،  تجربة فاخرة بانتظارك. لا تفوت الفرصة، احجز الآن لتعيش في قلب الرفاهية والرقي مع مقدم يبدء من 65800 درهم ",
    language: "ar"
  },
  // AZIZI - RIVIERA - RETAIL - EN
  {
    path: "/offer/azizi/riviera/retail",
    element: <AziziRivieraRetailNina language={"en"} />,
    pageName: "Azizi Riviera Retail",
    title: "Secure Your Spot at Dubai’s Central Boulevard – 10 Exclusive Commercial Units with Water Views!",
    description: "Invest in Dubai retail with 10 exclusive units offering customizable designs and 15%-20% ROI. Limited availability—secure your spot now",
    language: "en"
  },
  // AZIZI - RIVIERA - RETAIL - AR
  {
    path: "/offer/azizi/riviera/retail/ar",
    element: <AziziRivieraRetailNina language={"ar"} />,
    pageName: "Azizi Riviera Retail",
    title: "استثمر في أفضل الوحدات التجاريه بدبي -  وحدات حصرية مع رؤية مميزة وعائدات استثمارية عالية",
    description: "امتلك واحدة من 10 وحدات تجارية حصرية في دبي في مواقع مميزة. توفر هذه الوحدات رؤية رائعة للعلامات التجارية الدولية، مع عوائد استثمارية مميزة تصل إلى 20%.",
    language: "ar"
  },
  // AZIZI - RIVIERA - RETAIL - EN-S
  {
    path: "/offer/azizi/riviera/retail/en-s",
    element: <AziziRivieraRetailSnapchatNina language={"en"} />,
    pageName: "Azizi Riviera Retail",
    title: "Secure Your Spot at Dubai’s Central Boulevard – 10 Exclusive Commercial Units with Water Views!",
    description: "Invest in Dubai retail with 10 exclusive units offering customizable designs and 15%-20% ROI. Limited availability—secure your spot now",
    language: "en"
  },
  // AZIZI - RIVIERA - RETAIL - AR-S
  {
    path: "/offer/azizi/riviera/retail/ar-s",
    element: <AziziRivieraRetailSnapchatNina language={"ar"} />,
    pageName: "Azizi Riviera Retail",
    title: "استثمر في أفضل الوحدات التجاريه بدبي -  وحدات حصرية مع رؤية مميزة وعائدات استثمارية عالية",
    description: "امتلك واحدة من 10 وحدات تجارية حصرية في دبي في مواقع مميزة. توفر هذه الوحدات رؤية رائعة للعلامات التجارية الدولية، مع عوائد استثمارية مميزة تصل إلى 20%.",
    language: "ar"
  },
  // DAMAC - RIVERSIDE - EN 
  {
    path: "/offer/damac/riverside",
    element: <DamacRiversideNina language={"en"} />,
    pageName: "Damac Riverside",
    title: "Luxury Apartments in Dubai with a breathtaking 1500m-long river",
    description: "Luxury in Dubai: State-of-the-Art Fitness Center, Relaxing Spa, Children's Play Area, Thrilling Adventure Zone, and an Exclusive Gaming Zone for Unmatched Recreation.",
    language: "en"
  },
  // DAMAC - RIVERSIDE - AR
  {
    path: "/offer/damac/riverside/ar",
    element: <DamacRiversideNina language={"ar"} />,
    pageName: "Damac Riverside",
    title: "شقق فاخرة في دبي تتميز بنهر خلاب يمتد على طول 1500 متر، يوفر لك أجواء ساحرة وتجربة معيشية لا تُضاهى",
    description: "شقق فاخرة في دبي مع تجربة معيشية استثنائية نهر خلاب يمتد بطول 1500 متر، يحيط به مناظر طبيعية رائعة وأجواء هادئة تجمع بين الفخامة والجمال الطبيعي دفعه حجز 45.000 درهم ",
    language: "ar"
  },
  // DAMAC - RIVERSIDE - EN-S 
  {
    path: "/offer/damac/riverside/en-s",
    element: <DamacRiversideSnapchatNina language={"en"} />,
    pageName: "Damac Riverside",
    title: "Luxury Apartments in Dubai with a breathtaking 1500m-long river",
    description: "Luxury in Dubai: State-of-the-Art Fitness Center, Relaxing Spa, Children's Play Area, Thrilling Adventure Zone, and an Exclusive Gaming Zone for Unmatched Recreation.",
    language: "en"
  },
  // DAMAC - RIVERSIDE - EN-S 
  {
    path: "/offer/damac/riverside/ar-s",
    element: <DamacRiversideSnapchatNina language={"ar"} />,
    pageName: "Damac Riverside",
    title: "شقق فاخرة في دبي تتميز بنهر خلاب يمتد على طول 1500 متر، يوفر لك أجواء ساحرة وتجربة معيشية لا تُضاهى",
    description: "شقق فاخرة في دبي مع تجربة معيشية استثنائية نهر خلاب يمتد بطول 1500 متر، يحيط به مناظر طبيعية رائعة وأجواء هادئة تجمع بين الفخامة والجمال الطبيعي دفعه حجز 45.000 درهم ",
    language: "ar"
  },
  // AZIZI - MILAN - EN
  {
    path: "/offer/azizi/milan",
    element: <AziziMilanNina language={"en"} />,
    pageName: "Azizi Milan",
    title: "Dubai Meets Italy – Azizi Milan Apartments for Sale",
    description: "Live where Italy meets Dubai. Azizi Milan offers elegant studios to 3BR homes, world-class amenities & a prime location near IMG Worlds",
    language: "en"
  },
  // AZIZI - MILAN - AR
  {
    path: "/offer/azizi/milan/ar",
    element: <AziziMilanNina language={"ar"} />,
    pageName: "Azizi Milan",
    title: "دبي بطابع إيطالي – شقق Azizi Milan للبيع",
    description: "عيش في مكان يجمع بين سحر دبي وأناقة إيطاليا. Azizi Milan بتقدم شقق من ستوديو الى 3 غرف نوم، مع خدمات راقية وموقع استثنائي بجانب IMG Worlds.",
    language: "ar"
  },
  // AZIZI - MILAN - EN - S
  {
    path: "/offer/azizi/milan/en-s",
    element: <AziziMilanSnapchatNina language={"en"} />,
    pageName: "Azizi Milan",
    title: "Dubai Meets Italy – Azizi Milan Apartments for Sale",
    description: "Live where Italy meets Dubai. Azizi Milan offers elegant studios to 3BR homes, world-class amenities & a prime location near IMG Worlds",
    language: "en"
  },
  // AZIZI - MILAN - AR - S
  {
    path: "/offer/azizi/milan/ar-s",
    element: <AziziMilanSnapchatNina language={"ar"} />,
    pageName: "Azizi Milan",
    title: "دبي بطابع إيطالي – شقق Azizi Milan للبيع",
    description: "عيش في مكان يجمع بين سحر دبي وأناقة إيطاليا. Azizi Milan بتقدم شقق من ستوديو الى 3 غرف نوم، مع خدمات راقية وموقع استثنائي بجانب IMG Worlds.",
    language: "ar"
  },


  // HIKAL
  // AZIZI - VENICE - EN 
  // {
  //   path: "/projects/azizi/venice",
  //   element: <AziziVenice language={"en"} />,
  //   pageName: "Azizi Venice",
  //   title: "Luxury Apartments in Dubai – Find Your Dream Home!",
  //   description: "Your luxurious home in Dubai is waiting to fulfill all your dreams – Find your apartment today with only 65800 AED  down  payment",
  //   language: "en"
  // },
  // AZIZI - VENICE - AR
  // {
  //   path: "/projects/azizi/venice/ar",
  //   element: <AziziVenice language={"ar"} />,
  //   pageName: "Azizi Venice",
  //   title: "فرصة لا تعوض! شقق فاخرة في أفضل مواقع دبي للبيع.",
  //   description: "وحدات سكنيه ،  تجربة فاخرة بانتظارك. لا تفوت الفرصة، احجز الآن لتعيش في قلب الرفاهية والرقي مع مقدم يبدء من 65800 درهم ",
  //   language: "ar"
  // },
  // AZIZI - VENICE - EN - S
  // {
  //   path: "/projects/azizi/venice/en-s",
  //   element: <AziziVeniceSnapchat language={"en"} />,
  //   pageName: "Azizi Venice",
  //   title: "Luxury Apartments in Dubai – Find Your Dream Home!",
  //   description: "Your luxurious home in Dubai is waiting to fulfill all your dreams – Find your apartment today with only 65800 AED  down  payment",
  //   language: "en"
  // },
  // AZIZI - VENICE - AR - S
  // {
  //   path: "/projects/azizi/venice/ar-s",
  //   element: <AziziVeniceSnapchat language={"ar"} />,
  //   pageName: "Azizi Venice",
  //   title: "فرصة لا تعوض! شقق فاخرة في أفضل مواقع دبي للبيع.",
  //   description: "وحدات سكنيه ،  تجربة فاخرة بانتظارك. لا تفوت الفرصة، احجز الآن لتعيش في قلب الرفاهية والرقي مع مقدم يبدء من 65800 درهم ",
  //   language: "ar"
  // },
  // AZIZI - RIVIERA - RETAIL - EN
  // {
  //   path: "/projects/azizi/riviera/retail",
  //   element: <AziziRivieraRetail language={"en"} />,
  //   pageName: "Azizi Riviera Retail",
  //   title: "Secure Your Spot at Dubai’s Central Boulevard – 10 Exclusive Commercial Units with Water Views!",
  //   description: "Invest in Dubai retail with 10 exclusive units offering customizable designs and 15%-20% ROI. Limited availability—secure your spot now",
  //   language: "en"
  // },
  // AZIZI - RIVIERA - RETAIL - AR
  // {
  //   path: "/projects/azizi/riviera/retail/ar",
  //   element: <AziziRivieraRetail language={"ar"} />,
  //   pageName: "Azizi Riviera Retail",
  //   title: "استثمر في أفضل الوحدات التجاريه بدبي -  وحدات حصرية مع رؤية مميزة وعائدات استثمارية عالية",
  //   description: "امتلك واحدة من 10 وحدات تجارية حصرية في دبي في مواقع مميزة. توفر هذه الوحدات رؤية رائعة للعلامات التجارية الدولية، مع عوائد استثمارية مميزة تصل إلى 20%.",
  //   language: "ar"
  // },
  // AZIZI - RIVIERA - RETAIL - EN-S
  // {
  //   path: "/projects/azizi/riviera/retail/en-s",
  //   element: <AziziRivieraRetailSnapchat language={"en"} />,
  //   pageName: "Azizi Riviera Retail",
  //   title: "Secure Your Spot at Dubai’s Central Boulevard – 10 Exclusive Commercial Units with Water Views!",
  //   description: "Invest in Dubai retail with 10 exclusive units offering customizable designs and 15%-20% ROI. Limited availability—secure your spot now",
  //   language: "en"
  // },
  // AZIZI - RIVIERA - RETAIL - AR-S
  // {
  //   path: "/projects/azizi/riviera/retail/ar-s",
  //   element: <AziziRivieraRetailSnapchat language={"ar"} />,
  //   pageName: "Azizi Riviera Retail",
  //   title: "استثمر في أفضل الوحدات التجاريه بدبي -  وحدات حصرية مع رؤية مميزة وعائدات استثمارية عالية",
  //   description: "امتلك واحدة من 10 وحدات تجارية حصرية في دبي في مواقع مميزة. توفر هذه الوحدات رؤية رائعة للعلامات التجارية الدولية، مع عوائد استثمارية مميزة تصل إلى 20%.",
  //   language: "ar"
  // },

  // C6AP - APOELEZZ
  // AZIZI - MILAN - EN
  {
    path: "/c6ap/azizi/milan",
    element: <AziziMilanApoelezz language={"en"} />,
    pageName: "Azizi Milan",
    title: "Dubai Meets Italy – Azizi Milan Apartments for Sale",
    description: "Live where Italy meets Dubai. Azizi Milan offers elegant studios to 3BR homes, world-class amenities & a prime location near IMG Worlds",
    language: "en",
    bodyBackgroundClass: "black-bg"
  },
  // AZIZI - MILAN - AR
  {
    path: "/c6ap/azizi/milan/ar",
    element: <AziziMilanApoelezz language={"ar"} />,
    pageName: "Azizi Milan",
    title: "دبي بطابع إيطالي – شقق Azizi Milan للبيع",
    description: "عيش في مكان يجمع بين سحر دبي وأناقة إيطاليا. Azizi Milan بتقدم شقق من ستوديو الى 3 غرف نوم، مع خدمات راقية وموقع استثنائي بجانب IMG Worlds.",
    language: "ar",
    bodyBackgroundClass: "black-bg"
  },
  // BINGHATTI - AQUARISE - EN
  {
    path: "/c6ap/binghatti/aquarise",
    element: <BinghattiAquariseApoelezz language={"en"} />,
    pageName: "Binghatti Aquarise",
    title: "Business Bay Apartments – Skyline & Waterfront Views",
    description: "Experience striking architecture and luxury living in Business Bay. Studios to 4BR apartments with pools & skyline views. Waterfront lifestyle awaits.",
    language: "en",
    bodyBackgroundClass: "black-bg"
  },
  // BINGHATTI - AQUARISE - AR
  {
    path: "/c6ap/binghatti/aquarise/ar",
    element: <BinghattiAquariseApoelezz language={"ar"} />,
    pageName: "Binghatti Aquarise",
    title: "شقق الخليج التجاري - إطلالات على الأفق والواجهة البحرية",
    description: "اختبر روعة التصميم المعماري الفريد والحياة الفاخرة في الخليج التجاري. شقق من استوديو إلى 4 غرف نوم مع مسابح وإطلالات بانورامية. أسلوب حياة راقٍ على الواجهة المائية بانتظارك",
    language: "ar",
    bodyBackgroundClass: "black-bg"
  },
  // TIGER - ANANDA - EN
  {
    path: "/c6ap/tiger/ananda",
    element: <TigerAnandaApoelezz language={"en"} />,
    pageName: "Tiger Ananda",
    title: "Ananda Residences | Luxury Apartments in Motor City, Dubai",
    description: "Discover a masterpiece of modern luxury in the heart of Motor City. These twin towers offer elegantly designed apartments with breathtaking views, world-class amenities, and a flexible payment plan. Experience sophisticated living or seize a prime investment opportunity in Dubai.",
    language: "en",
    bodyBackgroundClass: "black-bg"
  },
  // TIGER - ANANDA - AR
  {
    path: "/c6ap/tiger/ananda/ar",
    element: <TigerAnandaApoelezz language={"ar"} />,
    pageName: "Tiger Ananda",
    title: "الأناندا ريزيدنس | شقق فاخرة في موتور سيتي، دبي",
    description: "اكتشف تحفة من الفخامة العصرية في قلب موتور سيتي. تقدم هذه الأبراج التوأم شققًا مصممة بأناقة مع إطلالات خلابة، ومرافق عالمية المستوى، وخطة دفع مرنة. تمتع بتجربة معيشية راقية أو اغتنم فرصة استثمارية مميزة في دبي.",
    language: "ar",
    bodyBackgroundClass: "black-bg"
  },

  // C8AS - ASM 
  // AZIZI - VENICE - EN 
  {
    path: "/c8as/azizi/venice",
    element: <AziziVeniceAsm language={"en"} />,
    pageName: "Azizi Venice",
    title: "Luxury Apartments in Dubai – Find Your Dream Home!",
    description: "Your luxurious home in Dubai is waiting to fulfill all your dreams – Find your apartment today with only 65800 AED  down  payment",
    language: "en",
    bodyBackgroundClass: "black-bg"
  },
  // AZIZI - VENICE - AR
  {
    path: "/c8as/azizi/venice/ar",
    element: <AziziVeniceAsm language={"ar"} />,
    pageName: "Azizi Venice",
    title: "فرصة لا تعوض! شقق فاخرة في أفضل مواقع دبي للبيع.",
    description: "وحدات سكنيه ،  تجربة فاخرة بانتظارك. لا تفوت الفرصة، احجز الآن لتعيش في قلب الرفاهية والرقي مع مقدم يبدء من 65800 درهم ",
    language: "ar",
    bodyBackgroundClass: "black-bg"
  },
  // AZIZI - MILAN - EN 
  {
    path: "/c8as/azizi/milan",
    element: <AziziMilanAsm language={"en"} />,
    pageName: "Azizi Milan",
    title: "Dubai Meets Italy – Azizi Milan Apartments for Sale",
    description: "Live where Italy meets Dubai. Azizi Milan offers elegant studios to 3BR homes, world-class amenities & a prime location near IMG Worlds",
    language: "en",
    bodyBackgroundClass: "black-bg"
  },
  // AZIZI - MILAN - AR
  {
    path: "/c8as/azizi/milan/ar",
    element: <AziziMilanAsm language={"ar"} />,
    pageName: "Azizi Milan",
    title: "دبي بطابع إيطالي – شقق Azizi Milan للبيع",
    description: "عيش في مكان يجمع بين سحر دبي وأناقة إيطاليا. Azizi Milan بتقدم شقق من ستوديو الى 3 غرف نوم، مع خدمات راقية وموقع استثنائي بجانب IMG Worlds.",
    language: "ar",
    bodyBackgroundClass: "black-bg"
  },
  // NOT FOUND 
  {
    path: "/*",
    element: <TestPage language={"en"} />,
    pageName: "Page Not Found",
    title: "DoDeal Properties Not Found",
    description: "DoDeal Properties",
  },
];

// HELMET MANAGER
const HelmetManager = ({ routes }) => {
  const location = useLocation();

  useEffect(() => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'pageview',
        page: location.pathname + location.search,
      });
    }
  }, [location]);

  // Normalize pathname for matching (remove trailing slashes)
  const normalizedPath = location.pathname.replace(/\/+$/, '');

  // const currentRoute = routes.find(route => route.path === location.pathname);
  // Find the matching route
  const currentRoute = routes.find(route => {
    const routePath = route.path.replace(/\/+$/, '');
    if (routePath === "/*") {
      return true; // Wildcard will match if no other route matches
    }
    return normalizedPath === routePath || (normalizedPath + '/') === routePath;
  });

  return (
    currentRoute && (
      <Helmet>
        <title>{currentRoute.title}</title>
        <meta name="description" content={currentRoute.description} />
        {/* PIXEL */}
        {/* Google Tag Manager - HIKAL - 250110 */}
        <script>
          {`
          (function (w, d, s, l, i) {
              w[l] = w[l] || [];
            w[l].push({"gtm.start": new Date().getTime(), event: "gtm.js" });
            var f = d.getElementsByTagName(s)[0],
            j = d.createElement(s),
            dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", "GTM-WM52CQMZ");
          `}
        </script>
        {/* End Google Tag Manager */}
      </Helmet>
    )
  );
};

const App = () => {
  const {
    setAllRoutes,
    i18n
  } = useStateContext();

  const location = useLocation();

  useEffect(() => {
    setAllRoutes(routes);
  }, []);

  useEffect(() => {
    setAllRoutes(routes);
    i18n.changeLanguage(localStorage.getItem("language"));
    document.body.style.direction = localStorage.getItem("direction");
    document.body.style.fontFamily = localStorage.getItem("font");
    // document.documentElement.style.setProperty("font-family", localStorage.getItem("font"));
  }, []);

  // Dynamically update body background class
  useEffect(() => {
    // Normalize pathname for matching (remove trailing slashes)
    const normalizedPath = location.pathname.replace(/\/+$/, '');

    // Find the matching route
    const currentRoute = routes.find(route => {
      const routePath = route.path.replace(/\/+$/, '');
      if (routePath === "/*") {
        return true; // Wildcard will match if no other route matches
      }
      return normalizedPath === routePath || (normalizedPath + '/') === routePath;
    });

    // Debugging logs
    console.log("Current Pathname:", location.pathname);
    console.log("Normalized Path:", normalizedPath);
    console.log("Current Route:", currentRoute);

    // List of all possible background classes
    const backgroundClasses = ["black-bg", "light-bg", "gradient-bg", "white-bg"];

    // Remove all background classes from body
    backgroundClasses.forEach(className => {
      document.body.classList.remove(className);
    });

    // Apply the new background class if specified
    if (currentRoute && currentRoute.bodyBackgroundClass) {
      console.log("Applying background class:", currentRoute.bodyBackgroundClass);
      document.body.classList.add(currentRoute.bodyBackgroundClass);
    } else {
      console.log("No background class specified for this route");
    }
  }, [location]);

  return (
    <HelmetProvider>
      <HelmetManager routes={routes} />
      {/* PIXEL */}
      {/* Google Tag Manager (noscript) - HIKAL - 250110 */}
      <noscript
      ><iframe
        src="https://www.googletagmanager.com/ns.html?id=GTM-WM52CQMZ"
        height="0"
        width="0"
        style="display: none; visibility: hidden"
      ></iframe></noscript>
      {/* End Google Tag Manager (noscript) */}

      {/* ROUTES */}
      <Routes>
        <Route path="/" element={<Home />} />
        {routes.map((route, index) => {
          return (
            <Route
              key={index}
              path={route.path}
              element={
                <LanguageWrapper language={route.language}>
                  {route.element}
                </LanguageWrapper>
              }
            />
          );
        })}
      </Routes>
    </HelmetProvider>
  );
}

export default App;
